module.exports = __webpack_public_path__ + "img/home_wenjian2.e9cb101e.png";